import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import Layout from '../../components/layout'
import SEO from '../../components/seo'
import ArticleHeader from '../../components/parent/article-header'
import Article from '../../components/parent/article2'
import UsefulTools from '../../components/parent/useful-tools'

const IndexPage = ({ location }) => {
  const data = useStaticQuery(graphql`
    query {
      ArticleHeaderImage1: file(
        relativePath: { eq: "parent/article-header2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1110) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      Tool1: file(relativePath: { eq: "parent/tools/gry.png" }) {
        childImageSharp {
          fluid(maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      Tool2: file(relativePath: { eq: "parent/tools/krzyzowki.png" }) {
        childImageSharp {
          fluid(maxWidth: 250) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <Layout location={location}>
      <SEO
        title="Jak wdrażać dzieci w prowadzenie dorosłego domowego budżetu?"
        description="Praktyczne sposoby i przykłady, jak rodzice mogą angażować dzieci do wspólnego zarządzania wpływami, planowania wydatków i oszczędności. A także co robić w razie niespodziewanych wydatków i jak motywować dzieci do oszczędzania."
        linkImage={data.ArticleHeaderImage1.childImageSharp.fluid.src}
      />

      <ArticleHeader
        image={data.ArticleHeaderImage1.childImageSharp.fluid}
        date="12.04.2021"
        title={
          <>
            Jak wdrażać dzieci
            <br />w{'\u00A0'}prowadzenie dorosłego
            <br />
            domowego budżetu?
          </>
        }
        desc={
          <p>
            Praktyczne sposoby i{'\u00A0'}przykłady, jak rodzice
            <br />
            mogą angażować dzieci do{'\u00A0'}wspólnego
            <br />
            zarządzania wpływami, planowania
            <br />
            wydatków i{'\u00A0'}oszczędności. A{'\u00A0'}także co{'\u00A0'}robić
            <br />w{'\u00A0'}razie niespodziewanych wydatków i{'\u00A0'}jak
            <br />
            motywować dzieci do{'\u00A0'}oszczędzania.
          </p>
        }
        linkPrev="/strefa-rodzica/baza-wiedzy"
        linkNext="/strefa-rodzica/baza-wiedzy#narzedzia"
      />
      <Article />
      <UsefulTools
        items={[
          {
            title: 'Krzyżówki',
            subtitle: 'Krzyżówka 2',
            image: data.Tool2,
            link: '/parent/Krzyzowka%202.pdf',
          },
          {
            title: 'Gry',
            subtitle: 'Budżet Samodzielniaka / Plansza i instrukcja',
            image: data.Tool1,
            link: '/parent/Budzet_Samodzielniaka_plansza_instrukcja.pdf',
          },
          {
            title: 'Gry',
            subtitle: 'Bankosłówka',
            image: data.Tool1,
            link: '/parent/Bankoslowka.pdf',
          },
        ]}
      />
    </Layout>
  )
}

export default IndexPage
